<div class="row animated fadeIn fast align-item-center">
  <div class="col"></div>
  
  <div class="col">
    <mat-card class="main-card">
      
      <div class="header-login">
        <div class="row container-logo">
          <div class="logo"></div>
        </div>
      </div>    
      <div class="content-bottom">          
        <div class="row container-button-login">
          <div class="col-sm">
            <button 
              mat-stroked-button 
              (click)="onSubmit()" 
              class="button-login">
                Login with SSO
            </button>
          </div>
        </div>
      </div>
       
    </mat-card>
  </div>

  <div class="col"></div>
</div>
